<script>
    import { onMount } from 'svelte';
    import Chart from 'chart.js/auto';
    import chartService from '../../../services/chart.js';
    import dayjs from 'dayjs';
    import { format } from 'svelte-i18n';

    let {
        findingsOpenData = [],
        findingsAcceptedData = [],
        findingsFixedData = [],
        findingsFalsePositiveData = []
    } = $props();

    let canvas = $state();
    let chart;
    let today = dayjs();
    today     = today.format('YYYY-MM-DD');

    const removeLastIndex = (object) => {
        delete object[today]
        return object;
    }
    findingsOpenData = removeLastIndex(findingsOpenData);
    findingsAcceptedData = removeLastIndex(findingsAcceptedData);
    findingsFixedData = removeLastIndex(findingsFixedData);
    findingsFalsePositiveData = removeLastIndex(findingsFalsePositiveData);

    var config = {
        type: 'line',
        responsive: true,
        maintainAspectRatio: false,
        options: {
            plugins: {
                legend: {
                    position: 'top',
                    display : true,
                    labels:{
                        font: {family: 'Montserrat'}
                    }
                },
                title: {
                    display   : false,
                    text      : 'Cantidad máxima por día',
                    font: {family: 'Montserrat'}
                },
            },

            elements: {
                line: {
                    tension: 0.5,
                    fill: false,
                    borderWidth: 3,
                },
                point: {
                    // Elements options apply to all of the options unless overridden in a dataset
                    // In this case, we are setting the border of each horizontal bar to be 2px wide
                    pointRadius: 2,
                    hoverRadius: 5
                }
            },
            scales: {
                x: {
                    stacked: false,
                    ticks: {
                        type: "timeseries",
                        font: {
                            family: 'Montserrat'
                        }
                    }
                },
                y: {
                    stacked: false,
                    ticks: {
                        beginAtZero : true,
                    },
                    font: {
                        family: 'Montserrat'
                    }
                }
            }
        }
    };

    onMount(async () => {

        let labels   = Object.keys(findingsOpenData);

        let datasets = [
            {
                label       : $format("finding.status.open"),
                borderColor : chartService.colors.status_blue,
                pointBackgroundColor: chartService.colors.status_blue,
                data        : Object.values(findingsOpenData)
            },
            {
                label       : $format("finding.status.accepted"),
                borderColor : chartService.colors.status_lblue,
                pointBackgroundColor: chartService.colors.status_lblue,
                data        : Object.values(findingsAcceptedData)
            },
            {
                label       : $format("finding.status.fixed"),
                borderColor : chartService.colors.status_gray,
                pointBackgroundColor: chartService.colors.status_gray,
                data        : Object.values(findingsFixedData)
            },
            {
                label       : $format("finding.status.false_positive"),
                borderColor : chartService.colors.status_lgray,
                pointBackgroundColor: chartService.colors.status_lgray,
                data        : Object.values(findingsFalsePositiveData)
            },
        ];

        config.data = {
            labels,
            datasets
        };

        let context = canvas.getContext('2d');
        chart   = new Chart(context, config);
    });
</script>

<canvas bind:this={canvas} id="chart-daily-max-count"></canvas>
